import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";
import ResourceAllocation from "@/pages/resourceAllocation/resource";
import HRResourceAllocation from "@/pages/resourceAllocation/hrresource";
const ResourceallocationRouter = [
  {
    path: "resourceallocation",
    element: (
      <SuspenseWrapper>
        <ResourceAllocation />
      </SuspenseWrapper>
    ),
  },
  {
    path: "HRResourceAllocation",
    element: (
      <SuspenseWrapper>
        <HRResourceAllocation />
      </SuspenseWrapper>
    ),
  },
];

export default ResourceallocationRouter;
